/* eslint-disable camelcase */
export enum EventName {
  RouteChange = 'gatsby-route-change',
  HeaderMenuClick = 'header_menu_click',
  RetailerClick = 'retailer_link_click',
  ViewSearchResults = 'view_search_results',
  ViewElement = 'view_element',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  GenerateLead = 'generate_lead',
  SelectPromotion = 'select_promotion',
  SelectItem = 'select_item',
  RetailerLinkConfirmation = 'retailer_link_click_confirmation',
  RetailerLinkRejection = 'retailer_link_click_rejection',
}

export type ProductItem = {
  item_id: string;
  item_name: string;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_variant: string;
  index?: number;
};

type BaseEventType = {
  event: EventName;
};

export type RouteChangeEvent = BaseEventType;

export type PageViewEvent = {
  page_template: string;
  promotion_name: null;
};

export type HeaderMenuClickEvent = BaseEventType & {
  click_text: string;
};

export type RetailerClickEvent = BaseEventType & {
  retailer_name: string;
  link_url: string;
};

export type ViewSearchResultsEvent = BaseEventType & {
  search_term: string;
};

export type ViewElementEvent = BaseEventType & {
  element_name: string;
};

export type ViewItemEvent = BaseEventType & {
  page_template: string;
  ecommerce: { items: ProductItem[] };
  index?: number;
};

export type ViewItemListEvent = BaseEventType & {
  ecommerce: { items: ProductItem[] };
  item_list_name: string;
};

export type FormSubmitEvent = BaseEventType & {
  form_name: string;
};

export type SelectPromotionEvent = BaseEventType & {
  ecommerce: { items: ProductItem[] };
  retailer_name: string;
  promotion_name: string;
};

export type SelectItemEvent = BaseEventType & {
  ecommerce: { items: ProductItem[] };
  item_list_name: string;
};

export type OtherOptions = {
  item_list_filter?: string;
  item_list_sort?: string;
  item_list_name?: string;
  index?: number;
};

export type RetailerLinkConfirmation = BaseEventType & {
  retailer_name: string;
  link_url: string;
};

export type RetailerLinkRejection = BaseEventType & {
  retailer_name: string;
  link_url: string;
};

export type GTMEvent =
  | RouteChangeEvent
  | PageViewEvent
  | HeaderMenuClickEvent
  | RetailerClickEvent
  | ViewSearchResultsEvent
  | ViewElementEvent
  | ViewItemEvent
  | ViewItemListEvent;
